import { IS_SERVER } from '@/constants/env';

export const getPageContainer = (): HTMLElement | null => {
    if (IS_SERVER) {
        return null;
    }
    const page = document.querySelector('#page');
    if (!(page instanceof HTMLElement)) {
        return null;
    }
    return page;
};

export const getHeaderContainer = (): HTMLElement | null => {
    if (IS_SERVER) {
        return null;
    }
    const header = document.querySelector('header');
    if (!(header instanceof HTMLElement)) {
        return null;
    }
    return header;
};

export const scrollPageContainerToTop = ({ behavior = 'smooth' }: { behavior?: 'instant' | 'smooth' } = {}) => {
    const page = getPageContainer();

    if (!page) {
        return;
    }

    page.scrollTo({ behavior, top: 0 });
};

export const scrollPageContainerToBottom = ({ behavior = 'smooth' }: { behavior?: 'instant' | 'smooth' } = {}) => {
    const page = getPageContainer();

    if (!page) {
        return;
    }

    page.scrollTo({ behavior, top: page.scrollHeight * 2 });
};
